import React from 'react'
import {Tasks} from './Tasks'
import { PercentageChart } from './CPUMeter';
import { CustomCardGrid } from './AgentDetails';
import {Grid } from "@mui/material";

export default function AgentsTab({
  selectedAgentDetail,
  tasksList,
  setectedAgentJobDetail,
  setTasksList,
  handleUserRequest,
  handleTaskAssign,
  handleAgentStatus,
  userRequests,
  setSelectedTask,
  selectedTask
}) {
  return (
    <div className='agent-details-container'>
      <div className='statistics-report'>
        <Grid container className="agents-chart-container">
          {selectedAgentDetail && ['cpu_percentage', 'disk_free_percentage', 'gpu_vram_percentage', 'ram_percentage'].map((percentageKey, index) => (
            <Grid item xs={12} sm={6} md={3} key={percentageKey} >
              <PercentageChart percentage={selectedAgentDetail[percentageKey]} label={percentageKey} />
            </Grid>
          ))
          }
        </Grid>
      </div>
      <CustomCardGrid
        selectedAgentDetail={selectedAgentDetail}
      />
      <Tasks 
      tasksList={tasksList}
      setectedAgentJobDetail={setectedAgentJobDetail}
      setTasksList={setTasksList}
      handleUserRequest={handleUserRequest}
      handleTaskAssign={handleTaskAssign}
      handleAgentStatus={handleAgentStatus}
      selectedTask={selectedTask}
              setSelectedTask={setSelectedTask}
      userRequests={userRequests}
      />
    </div>
  )
}
